import { useMutation } from 'react-query';
import { API } from '../../../CommonUtils/axiosWithDefaults';

interface CreateReconciliationBatchParams {
  clientId: number;
  file: File;
}

export interface CreateReconciliationBatchResult {
  batchId: string;
  itemId: string;
}

const createReconciliationBatch = async ({
  clientId,
  file,
}: CreateReconciliationBatchParams): Promise<CreateReconciliationBatchResult> => {
  const formData = new FormData();
  formData.append('file', file);
  return API.post(
    `/Adviser/PdfImport/CreateReconciliationBatch?clientId=${encodeURIComponent(clientId)}`,
    formData,
  );
};

export const useCreateReconciliationBatchMutation = () => {
  return useMutation(createReconciliationBatch);
};
